import React from 'react';
import CustomImage from '../../../components/custom-image';
import Collapse from '../../../components/collapse';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const Casestudy1 = () => {
  return (
    <div className="container-fluid">
      <div className="social-development-container top-section">
      <ScrollPositionAnimation targetElement1="anim-six" targetElement2="anim-seven">
        <div className="section-inner">
          <div className="left-img">
            <div className="left-to-right anim-six">
              <div className="desktop-img">
                <CustomImage imageName="nandghar-barmer-village.jpg" alt="Nand Ghar programme" maxWidth="635" />
              </div>
            </div>
          </div>
          <div className="right-content p-t-0">
            <div className="bottom-to-top anim-seven">
            <p className="small-text">CASE STUDY 01:</p>
            <h3 className="bold-text blue-text">NANDGHAR</h3>
            <div className="mobile-img">
              <CustomImage imageName="nandghar-barmer-village.jpg" alt="Nand Ghar programme" maxWidth="767" />
            </div>
            <p>Our flagship Nand Ghar programme, which has seen phenomenal growth and success since its inception, is a child and maternal health initiative
              designed to support the Government of India’s Child Development Services (ICDS). At Nand Ghar, the traditional Anganwadi or rural childcare centre
              is reimagined as a state-of-the-art mother and child community hub, that provides crucial aid in the early stages of child’s growth, and offers
              women with a platform to learn new skills.
            </p>
            <p>Our ambitious venture equips the Nand Ghars with rooftop solar panels for 24x7 electricity supply, water purifiers and clean lavatories,
              while addressing the nutritional and education needs of young children. With their hands free during the Nand Ghar hours, the mothers are given the
              opportunity to get trained in special skills that could aid in their economic upliftment. 
            </p>
            <Collapse labelOne="Read More" labelTwo="Read Less">
              <p>This has directly impacted over 44,000 children benefiting from the pre-school programme, while over 29,000 of them enjoy nutritious
                meals daily. Powering on, we intend to open as many as 4,000 Nand Ghars throughout the country which, alongside our Khushi initiative, will
                impact millions of children and women.
              </p>
              <p> During FY2020, we operationalised our 1,302<sup>nd</sup> Nand Ghar – which can now be found across Rajasthan, Uttar Pradesh, Odisha, Jharkhand, Chattisgarh, Madhya
                Pradesh, and Karnataka.
              </p>
            </Collapse>
            <div className="blue-box">
              <p><strong>SDG Alignment</strong></p>
              <ul>
                <li><span>Goal: SDG 2-</span> Zero Hunger</li>
                <li><span>Target:</span> 2.1. End hunger and ensure access to safe, nutritious, and sufficient food, all year round</li>
              </ul>
            </div>
            </div>
          </div>
        </div>
       </ScrollPositionAnimation>
      </div>
    </div>
  );
};

export default Casestudy1;
